import { useQuery } from '@tanstack/react-query';
import { knowledgeBaseWorkspacesQuery } from '../../api/knowledgeBaseWorkspaces.api';
import { useKnowledgeBaseModal } from '../knowledge-base-modal.store';
import type { KnowledgeBaseDto } from '../knowledge-bases.types';

/**
 * The workspaces the knowledge base being edited is shared with. The summary names only the first
 * of them, so the rest load separately.
 */
export const useKbWorkspaceSelection = (knowledgeBase: KnowledgeBaseDto | undefined) => {
  const { knowledgeBaseModalTypeEdit } = useKnowledgeBaseModal();

  const { data: scope } = useQuery({
    ...knowledgeBaseWorkspacesQuery(knowledgeBase?.id),
    // Loaded for an organization-wide knowledge base too: it keeps the workspaces it was shared
    // with, so switching back to chosen workspaces can offer them again.
    enabled: knowledgeBaseModalTypeEdit && !!knowledgeBase?.id && !knowledgeBase.isInternal,
  });

  return { scope };
};
